import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CURRENT_VERSION = "0.20.0";
const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export default function VersionNotification() {
    const { t } = useTranslation();
    const [showNotification, setShowNotification] = useState(false);
    const [newVersion, setNewVersion] = useState("");

    const checkVersion = async () => {
        try {
            // Fetch version.json with cache busting
            const response = await fetch(`/version.json?t=${Date.now()}`);
            if (response.ok) {
                const data = await response.json();
                const serverVersion = data.version;

                // Compare versions
                if (serverVersion && serverVersion !== CURRENT_VERSION) {
                    setNewVersion(serverVersion);
                    setShowNotification(true);
                }
            }
        } catch (error) {
            console.error('Error checking version:', error);
        }
    };

    useEffect(() => {
        // Check immediately on mount
        checkVersion();

        // Then check periodically
        const interval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

        return () => clearInterval(interval);
    }, []);

    const handleReload = () => {
        window.location.reload();
    };

    const handleDismiss = () => {
        setShowNotification(false);
    };

    if (!showNotification) {
        return null;
    }

    return (
        <div className="version-notification">
            <div className="version-notification-content">
                <i className="bi bi-info-circle"></i>
                <div className="message">
                    <strong>{t("New version available")}</strong>
                    <span>{t("Version")} {newVersion} {t("is available. Reload to update.")}</span>
                </div>
                <div className="actions">
                    <button className="btn btn-primary btn-sm" onClick={handleReload}>
                        {t("Reload")}
                    </button>
                    <button className="btn btn-secondary btn-sm" onClick={handleDismiss}>
                        {t("Later")}
                    </button>
                </div>
            </div>
        </div>
    );
}
